import React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { Card } from 'web/components/Card';

const EmailConfirmedPage = () => {
    const [orgId] = useQueryParam('org', StringParam);
    const [email] = useQueryParam('email', StringParam);
    
    return (
        <Card>
            Your email is verified.<br />
            {
                orgId ? (
                    <>
                        <a href={`/SelectSubscription?orgId=${orgId}&email=${email}`} className='text-[#26818E] underline font-semibold'>Click here</a> to subscribe to NXVET.
                    </>
                ) : (
                    <>
                        <a href="/" className='text-[#26818E] underline font-semibold'>Click here</a> to login on NXVET.
                    </>
                )
            }
        </Card>
    )
};

export default EmailConfirmedPage;
